import React from 'react';
import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

function AmberSectionTitleNoMargin(props) {
  const { text, typographyVariant, typographyClasses, ...rest } = props;

  return (
    <Typography
      variant={typographyVariant || 'h6'}
      {...(typographyClasses ? { classes: { ...typographyClasses } } : {})}
    >
      <Box display="block" component="span" {...rest}>
        {text}
      </Box>
    </Typography>
  );
}
AmberSectionTitleNoMargin.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  typographyVariant: PropTypes.string,
  typographyClasses: PropTypes.objectOf(PropTypes.string),
};
AmberSectionTitleNoMargin.defaultProps = {
  typographyVariant: 'h6',
  typographyClasses: null,
};

export default AmberSectionTitleNoMargin;
